module.exports = __webpack_public_path__ + "static/media/1016023.4f39e8aa.jpg";